import { render, staticRenderFns } from "./area-documentation.component.vue?vue&type=template&id=5c3d031f"
import script from "./area-documentation.component.ts?vue&type=script&lang=ts&external"
export * from "./area-documentation.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports